module.exports = __webpack_public_path__ + "img/brief-foreplay-icon.9acee5cd.svg";